try {
    const key = 'localStorageTest' + Date.now();
    localStorage.setItem(key, key);
    const get = localStorage.getItem(key);
    localStorage.removeItem(key);
    if (get !== key) {
        throw 0;
    }
} catch (e) {
    function clear() {
        const store = {
            setItem(id, val) {
                return store[id] = String(val);
            },
            getItem(id) {
                return store.hasOwnProperty(id) ? String(store[id]) : void 0;
            },
            removeItem(id) {
                return delete store[id];
            },
            clear
        };
        window.localStorage = store;
    }
    clear();
}
